import React from "react";

import { AW21 } from "../../../../js/database/database-aw21.js";

import TopMenuProducts from "../../../../components/topmenuproducts";
import SwiperInit from "../../../../components/SwiperInit";
import InfoItem from "../../../../components/infoItem";
import Loader from "../../../../components/loader";

import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
import GlobalMetaTags from "../../../../components/globalMetaTags";
import SizeChart from "../../../../components/sizeChart.js";

class KnitTankRedOlive extends React.Component {

    render() {
        return (
            <div>
                <GlobalMetaTags
                    pageTitle={AW21.tops.KnitTankRedOlive.itemName}
                />
                <Loader />
                <TopMenuProducts
                    name={AW21.tops.KnitTankRedOlive.itemName}
                />
                <InfoItem
                    price={AW21.tops.KnitTankRedOlive.itemPrice}
                    fabric={AW21.tops.KnitTankRedOlive.itemFabric}
                />
                <SizeChart src={AW21.tops.KnitTankRedOlive.sizeChart} />
                <div className="swiper-container" id="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.KnitTankRedOlive.picture01}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.KnitTankRedOlive.picture02}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.KnitTankRedOlive.picture03}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.KnitTankRedOlive.picture04}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.KnitTankRedOlive.picture05}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.KnitTankRedOlive.picture06}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.KnitTankRedOlive.picture07}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
                <ShopifyMainComponent
                    divId={AW21.tops.KnitTankRedOlive.shopifyDivId}
                    mainId={AW21.tops.KnitTankRedOlive.shopifyId}
                />
                <SwiperInit />
            </div>
        );
    }
}

export default KnitTankRedOlive;
